module.exports = __webpack_public_path__ + "img/Aprendizaje.e3076d16.svg";